import Tracker from './Tracker';

const onboardingTracker = new Tracker('onboarding', {
	SKIP: 'skip',
	START: 'start',
	COMPLETED: 'completed'
});

export default onboardingTracker;
